import { TextArea as TextAreaComponent } from '@randstad-lean-mobile-factory/react-components-core';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../ErrorMessage';

import { TextAreaProps } from './TextArea.types';

export const TextArea = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  name,
  control,
  defaultValue,
  disabled,
  formFieldClassName,
  ...textAreaProps
}: TextAreaProps<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  return (
    <div className={formFieldClassName}>
      <TextAreaComponent {...textAreaProps} {...field} error={!!error} value={field.value ?? ''} />
      <ErrorMessage error={error} />
    </div>
  );
};
